/* eslint-disable consistent-return */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-console */
import { ApolloClient, InMemoryCache, fromPromise, ApolloLink } from "@apollo/client";
import { GraphQLWsLink } from "@apollo/client/link/subscriptions";
import { getMainDefinition, relayStylePagination } from "@apollo/client/utilities";
import { onError } from "@apollo/link-error";
import { toast } from "react-toastify";

import { createClient } from "graphql-ws";

import MultiAPILink from "startup/MultiAPILink";

import getNewToken from "utils/getNewToken";

function createWsLink() {
  return new GraphQLWsLink(
    createClient({
      url: import.meta.env.REACT_APP_GRAPHQL_API_WS,
      connectionParams: () => ({
        authorization: localStorage.getItem("authToken"),
      }),
      shouldRetry: () => true,
    }),
  );
}

let wsLink = createWsLink();

const errorLink = onError(({ graphQLErrors, networkError, operation, forward }) => {
  if (graphQLErrors) {
    for (const err of graphQLErrors) {
      const { message, location, path, extensions } = err;

      if (message.includes("You do not have access")) {
        if (window) window.location.replace("/app");
      }

      if (message.includes("prisma.supportCalculation.update()")) {
        localStorage.setItem("hasError", "true");
        if (window) window.location.reload();
      }

      if (
        message.includes("Two-factor authentication") &&
        (message.includes("required") || message.includes("enforced")) &&
        message.includes("set up 2FA")
      ) {
        // Show toast notification

        toast.error(
          "Action blocked: Two-factor authentication is required. Please set up 2FA to continue.",
          {
            toastId: "mfa-required", // Prevent duplicate toasts
            autoClose: 5000,
          },
        );

        setTimeout(() => {
          const event = new CustomEvent("mfa-enforcement-blocked", {
            detail: { operation: operation.operationName, path },
          });
          window.dispatchEvent(event);
        }, 1500);
      }

      if (extensions?.code === "UNAUTHENTICATED") {
        const oldToken = localStorage.getItem("authToken");

        if (oldToken) {
          // eslint-disable-next-line no-loop-func
          return fromPromise(getNewToken()).flatMap((accessToken) => {
            const oldHeaders = operation.getContext().headers;

            if (accessToken) {
              localStorage.setItem("authToken", accessToken);

              // Dispose of old WebSocket connection before creating new one
              if (wsLink && typeof wsLink.dispose === "function") {
                wsLink.dispose();
              }
              wsLink = createWsLink();
            } else {
              localStorage.removeItem("authToken");
              window.location.reload();
            }

            operation.setContext({
              headers: {
                ...oldHeaders,
                Authorization: accessToken,
              },
            });

            return forward(operation);
          });
        }
      }

      const textError = `[GraphQL error]: ${message}, Location: ${location}, Path: ${path}`;

      console.error(textError);
    }
  }

  if (networkError) {
    console.error(`[Network error]: ${networkError}`);
  }
});

const multiLink = new MultiAPILink();

const link = ApolloLink.from([
  errorLink,
  ApolloLink.split(
    ({ query }) => {
      const definition = getMainDefinition(query);
      return definition.kind === "OperationDefinition" && definition.operation === "subscription";
    },
    wsLink,
    multiLink,
  ),
]);

const cache = new InMemoryCache({
  typePolicies: {
    Query: {
      fields: {
        documentsConnection: relayStylePagination(["where"]),
      },
    },
    Client: {
      fields: {
        budgetItems: {
          merge(existing = [], incoming = []) {
            // Create a merged array that preserves all references from both arrays
            return Array.isArray(incoming) ? incoming : existing;
          },
        },
        exBudgetItems: {
          merge(existing = [], incoming = []) {
            // Same merge logic for exBudgetItems
            return Array.isArray(incoming) ? incoming : existing;
          },
        },
      },
    },
  },
});

const client = new ApolloClient({
  link,
  cache,
});

export default client;
